/**
 * [Useful modules]
 */

let exports = new Object();

/**
 * Affiche le nombre d'item(s), avec son type correspondant (accordé au pluriel selon le nb)
 * Ex: 1 article || 5 résultats
 *
 * @param currentCount (int)
 * @param placeholder (string)
 */
exports.displayNbOfItems = function (currentCount, placeholder) {

    if (currentCount <= 1) {
        $('[data-role="counter"]').text(currentCount + " " + placeholder);
    } else {
        $('[data-role="counter"]').text(currentCount + " " + placeholder + "s");
    }

};

/**
 * Renvoie sur la page parente (retire tous les params en GET dans l'URL)
 */
exports.resetChoice = function () {
    let rawUrl = location.protocol + '//' + location.host + location.pathname;

    // renvoie sur la page parente
    window.location.assign(rawUrl);
};

/**
 * Renvoie le nom du jour courant au format texte
 */
exports.isCurrentDayName = function () {

    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let day = new Date();
    let name = day.getDay();

    return days[name];
};

export default exports;
